import React from "react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { fileUrl } from "@/lib/api";

export default function Affiliations({ data }) {
  if (!data || data.hidden) return null;
  const logos = data.logos || [];
  if (!logos.length) return null;
  const row = [...logos, ...logos];

  return (
    <section data-testid="affiliations" className="border-y border-gold/10 bg-obsidian px-6 py-20 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <Eyebrow>{data.heading || "Affiliations & Networks"}</Eyebrow>
          {data.subheading && <p className="mt-4 max-w-xl font-sans text-sm leading-relaxed text-softgrey">{data.subheading}</p>}
        </Reveal>
      </div>

      <div className="group relative mt-12 overflow-hidden">
        <div className="flex w-max animate-marquee items-center gap-16 group-hover:[animation-play-state:paused]">
          {row.map((l, i) => (
            <div key={i} className="flex h-16 w-44 shrink-0 items-center justify-center" title={l.name} data-testid={`affiliation-${i}`}>
              {l.image
                ? <img src={fileUrl(l.image)} alt={l.name} className="max-h-12 max-w-full object-contain opacity-55 grayscale transition duration-300 hover:opacity-100 hover:grayscale-0" />
                : <span className="font-serif text-lg text-softgrey/70">{l.name}</span>}
            </div>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-28 bg-gradient-to-r from-obsidian to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-28 bg-gradient-to-l from-obsidian to-transparent" />
      </div>
    </section>
  );
}
